import taskService from 'resources/task/task.service';

import * as taskOperations from 'resources/task/task.operations';
import { deleteTask } from './deleteTask';

/**
 * Delete one single task with document and reorder the milestone tasks
 * for delete all tasks of the milestone, use
 * ```deleteAllMilestoneTasks``` instead
 * @param id
 * @returns {Promise<*|null>}
 */
const deleteTaskWithDocument = async ({ id }) => {
  const removedTask = await deleteTask({ id });
  if (!removedTask) {
    return null;
  }

  const milestoneId = removedTask.milestone_id;

  const [milestoneTasks] = await Promise.all([
    taskService.getMilestoneTasks(milestoneId),
  ]);

  await Promise.all([
    taskOperations.reorderMilestoneTasks({
      milestoneId,
      tasks: milestoneTasks,
    }),
  ]);

  return removedTask;
};

export {
  deleteTaskWithDocument,
};
